export const DEFAULT_TOAST_IMAGE = "DEFAULT_TOAST_IMAGE";